import { useEffect, useState } from 'react';

// Matches Tailwind's default md (768px) and lg (1024px) breakpoints.
const TABLET_MIN = 768;
const DESKTOP_MIN = 1024;

const compute = () => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return { isMobile: false, isTablet: false, isDesktop: true };
  }
  const isDesktop = window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`).matches;
  const isTablet =
    !isDesktop && window.matchMedia(`(min-width: ${TABLET_MIN}px)`).matches;
  return { isMobile: !isDesktop && !isTablet, isTablet, isDesktop };
};

const useBreakpoint = () => {
  const [state, setState] = useState(compute);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const queries = [
      window.matchMedia(`(min-width: ${TABLET_MIN}px)`),
      window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`),
    ];
    const update = () => setState(compute());
    queries.forEach((q) => q.addEventListener('change', update));
    update();
    return () => queries.forEach((q) => q.removeEventListener('change', update));
  }, []);

  return state;
};

export default useBreakpoint;
